module.exports = __webpack_public_path__ + "img/facebook.57cd623f.svg";